import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FirebaseOptions } from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  FIREBASECONFIG: FirebaseOptions;
  constructor(private http: HttpClient) {}

  getFirebaseConfig(hotelId: number): Promise<FirebaseOptions> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.awsURL + hotelId + '/configs/firebaseWebConfig.json')
        .subscribe({
          next: (data: FirebaseOptions) => {
            this.FIREBASECONFIG = data;
            resolve(data);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            // this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }
}
